// src/lib/pdfjs.ts — shared pdfjs-dist lazy loader.
//
// pdfjs-dist ships ~1.23 MB of code (including its worker). It is only
// needed when PDF rendering is active (plate overlay or plate-correction
// editor). Loading it lazily keeps that weight off the cold-start critical
// path — audit 2026-05-22 measured this as the single largest deferrable
// chunk.
//
// `loadPdfjs()` caches the resolved module so subsequent callers reuse
// the already-loaded library. Worker URL is configured on first load.
//
// Consumers:
//   - src/map/plateOverlay/renderPlateBitmap.ts
//   - src/plates/PlateCorrectionEditor.tsx
//
// ME-10 (audit-synthesis-2026-05-24): consolidates the duplicate
// loadPdfjs definitions that previously lived in each consumer.

export type PdfjsModule = typeof import('pdfjs-dist');

let _pdfjsLib: PdfjsModule | null = null;
let _pdfjsLoading: Promise<PdfjsModule> | null = null;

export async function loadPdfjs(): Promise<PdfjsModule> {
  if (_pdfjsLib) return _pdfjsLib;
  if (_pdfjsLoading) return _pdfjsLoading;
  _pdfjsLoading = (async () => {
    const mod = await import('pdfjs-dist');
    // Worker URL must be resolved relative to this module so Vite
    // emits the worker as a static asset alongside the main bundle.
    mod.GlobalWorkerOptions.workerSrc = new URL(
      'pdfjs-dist/build/pdf.worker.min.mjs',
      import.meta.url,
    ).toString();
    _pdfjsLib = mod;
    return mod;
  })();
  return _pdfjsLoading;
}
